import { combineReducers } from 'redux';

import {
  SETTING_ACCOUNT_RELOAD_DATA,
  SETTING_ACCOUNT_SHOW_ALL,
  SETTING_ACCOUNT_SHOW_PROFILE,
  SETTING_ACCOUNT_SHOW_BUSINESS,
  SETTING_ACCOUNT_SHOW_PASSWORD,
  SETTING_ACCOUNT_SET_PROFILE,
  SETTING_ACCOUNT_SET_BUSINESS,
  SETTING_ACCOUNT_SET_KYB,
  SETTING_ACCOUNT_SET_KYB_INCOMPLETE,
  SETTING_ACCOUNT_SHOW_OTP_MODAL,
  SETTING_ACCOUNT_SET_OTP_ERROR_MSG,
  SETTING_ACCOUNT_SET_OTP_REQUEST_ID,
  SETTING_ACCOUNT_SET_STATUS_CODE,
  SETTING_ACCOUNT_SHOW_NPWP,
} from '../../actions/setting/account/constants';
import createReducer from '../../utils/createReducer';

const businessKyb = createReducer(
  {},
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [SETTING_ACCOUNT_SET_BUSINESS]: (draft, { payload }) => payload.data,
  }
);

const currentPage = createReducer('SHOW_DETAIL', {
  [SETTING_ACCOUNT_RELOAD_DATA]: (draft, { payload }) => payload,

  [SETTING_ACCOUNT_SHOW_ALL]: (draft, { payload }) => payload,

  [SETTING_ACCOUNT_SHOW_PROFILE]: (draft, { payload }) => payload,

  [SETTING_ACCOUNT_SHOW_BUSINESS]: (draft, { payload }) => payload,

  [SETTING_ACCOUNT_SHOW_NPWP]: (draft, { payload }) => payload,

  [SETTING_ACCOUNT_SHOW_PASSWORD]: (draft, { payload }) => payload,
});

const kyb = createReducer(
  {},
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [SETTING_ACCOUNT_SET_KYB]: (draft, { payload }) => payload.data,
  }
);

const kybIncomplete = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SETTING_ACCOUNT_SET_KYB_INCOMPLETE]: (draft, { payload }) => payload.data,
});

const otpErrorMsg = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SETTING_ACCOUNT_SET_OTP_ERROR_MSG]: (draft, { payload }) => payload.otpError,
});

const otpModal = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SETTING_ACCOUNT_SHOW_OTP_MODAL]: (draft, { payload }) => payload.showModal,
});

const otpRequestId = createReducer(null, {
  [SETTING_ACCOUNT_SET_OTP_REQUEST_ID]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.requestId,
});

const otpStatusCode = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SETTING_ACCOUNT_SET_STATUS_CODE]: (draft, { payload }) => payload.statusCode,
});

const passwordConfirmation = createReducer('', {});

const profile = createReducer(
  { business: {} },
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [SETTING_ACCOUNT_SET_PROFILE]: (draft, { payload }) => payload.data,
  }
);

// FIXME camelcase
export default combineReducers({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  business_kyb: businessKyb,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  current_page: currentPage,
  kyb,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  kyb_incomplete: kybIncomplete,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  otp_error_msg: otpErrorMsg,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  otp_modal: otpModal,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  otp_request_id: otpRequestId,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  otp_status_code: otpStatusCode,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  password_confirmation: passwordConfirmation,
  profile,
});
